<template>
  <div id="app">

    <header class="header">
      <div class="dec">
        <span class="bar bar1"></span>
        <span class="bar bar2"></span>
        <span class="bar bar3"></span>
        <span class="bar bar4"></span>
        <span class="bar bar5"></span>
        <span class="bar bar6"></span>
      </div>
      <div class="header-title">
        <span class="title-h">訂單資訊</span>
        <div class="nav-btn">
          <span class="nav"></span>
          <span class="nav"></span>
          <span class="nav"></span>
        </div>
      </div>
      <div class="header-box">
        <div class="header-line">
          <span :class="{active_l1 : pathBar===1, active_l2 : pathBar===2}" class="line">
            <span class="dot dot1"></span>
            <span :class="{active_p : pathBar===2}" class="dot dot2"></span>
            <span :class="{active_p : pathBar===1 || pathBar===2}" class="dot dot3"></span>
          </span>
        </div>
      </div>
      <div class="header-text">      
        <span :class="{active_t : pathBar===1 || pathBar===2}" class="text">Step1 選定支付方式</span>
        <span :class="{active_t : pathBar===2}" class="text">Step2 輸入信用卡資訊或取得支付代碼</span>
      </div>
    </header>
    <keep-alive>
      <router-view/>
    </keep-alive>
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <footer class="footer">Copy right Hello I'm Footer :)</footer>
  </div>
</template>

<style lang="scss">
//**************Gobal***************
*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  color: $dark-color;
}
body{
  overflow-x:hidden;
  overflow-y:auto;
}
h1,h2,h3,h4,h5,h6,span,a,button{
  display: inline-block;
  text-decoration: none;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
}
button,select{
  display: inline-block;
  outline: none;
  border: none;
  cursor: pointer;
  background:none;
}
//*********************************
#app {
  font-family: 'Noto Sans TC','Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
.header{
  width: 100%;
  height: 164px;
  text-align: center;
  .dec{
    margin-top: -4px;
    width: 100%;
  }
  .header-title{
    width: 100%;
    text-align: center;
    margin: 15px 0;
    .title-h{
    font-size: 30px;
    color: $primary-color;
    text-align: center;
    font-weight: 700;
    }
  }
  .header-line{
    width: 680px;
    line-height: 11.5px;
    height: 20px;
    text-align: center;
    display: inline-block;
    position: relative;
  }
  .header-text{
    display: inline-block;
    width: 680px;
  }
}
.footer{
  width: 100%;
  background-color: $primary-color;
  height: 50px;
  font-size: 12px;
  color: $mid-color;
  line-height: 50px;
}
.bar{
  height: 15px;
  &.bar1{
    width: 140/1024 * 100%;
    background-color: $mid-color;
  }
  &.bar2{
    width: 220/1024 * 100%;
    background-color: $btn-color;
  }
  &.bar3{
    width: 95/1024 * 100%;
    background-color: $primary-color;
  }
  &.bar4{
    width: 230/1024 * 100%;
    background-color: $warning-color;
  }
  &.bar5{
    width: 190/1024 * 100%;
    background-color: #CC251B;
  }
  &.bar6{
    width: 149/1024 * 100%;
    flex-grow:2;
    background-color: $secondary-color;
  }
}
.line{
  width: 100%;
  background-image: linear-gradient(to right,$secondary-color 0%, $mid-color 0%);
  height: 3px;
  &.active_l1{
    background-image: linear-gradient(to right,$secondary-color 50%, $mid-color 50%);
  }
  &.active_l2{
    background-image: linear-gradient(to right,$secondary-color 100%, $mid-color 100%);
  }
}
.dot{
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: $mid-color;
  position: absolute;
  top: 0;
  &.dot1{
    left: 0;
    background-color: $secondary-color;
  }
  &.dot2{
    right: 0;
  }
  &.dot3{
    left: 50%;
    transform: translateX(-50%);
  }
  &.active_p{
    background-color: $secondary-color;
  }
}
.text{
  font-size: 14px;
  color: $mid-color;
  width: 50%;
  &.active_t{
    color: $secondary-color;
  }
}

//******************media****************
@media screen and (max-width:415px){
  .header{
    height: 107px;
    .dec{
      margin-top: -9px;
    }
    .header-title{
      display: inline-block;
      position: relative;
      margin: 12px 0;
      text-align: left;
      .title-h{
        margin-left: 15px;
        text-align: left;
        font-size: 20px;
      }
    }
    .header-line{
      width: 290px;
      line-height: 11.5px;
      height: 15px;
    }
    .header-text{
      display: none;
    }
  }.bar{
    height: 10px;
  }
  .nav-btn{
    position: absolute;
    top: 50%;
    right: 15px;
    transform: translateY(-50%);
    width: 15px;
    height: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    
    cursor: pointer;
    .nav{
      width: 15px;
      height: 3px;
      background-color: $dark-color;
    }
  }
}
</style>

<script>
export default {
  name: 'beginPage',
  data: function(){
    return{
      styleObj:{
        backgroundImage: 'linear-gradient(to right,$secondary-color 50%, $mid-color 50%)'
      }
    }
  },
  computed: {
    page () {
      return this.$route.path
    },
    pathBar () {
      if (this.page.indexOf('pay') > -1) {
        return 1
      }else if (this.page.indexOf('done') > -1){
        return 2
      }else{
        return 0
      }
    },
    percent(){
      if (this.page.indexOf('pay') > -1) {
        return '50%'
      }else if (this.page.indexOf('done') > -1){
        return '100%'
      }else{
        return '0%'
      }
    }
  }
}
</script>
